'use client';

import dynamic from 'next/dynamic';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';

const CarvanaPageHeader = dynamic(
  () => import(/* webpackChunkName: "PageHeader" */ './CarvanaPageHeader')
);

const DealershipPageHeader = dynamic(
  () =>
    import(
      /* webpackChunkName: "DealershipPageHeader" */ '@/dealership/PageHeader'
    )
);

type OwnProps = {
  pathname?: string;
};

export default function PageHeader({ pathname }: OwnProps) {
  const isDealership = useIsDealershipPage();

  return isDealership ? (
    <DealershipPageHeader />
  ) : (
    <CarvanaPageHeader pathname={pathname} />
  );
}
